import React from 'react';
import {Helmet} from 'react-helmet-async';
import {SFC} from 'types/generic';

export interface PageTitleProps {
  ogDescription?: string;
  ogImageUrl?: string;
  ogTitle?: string;
  ogType?: 'website' | 'article' | 'profile' | 'book';
  ogUrl?: string;
  title: string;
}

export const defaultOg = {
  description:
    '象寄图片翻译，图片网盘，图片去水印，图片抠图，图床，视频翻译，image translate, video translate, Image watermark removal',
  imageUrl: 'https://i.tosoiot.com/static/images/logo.png',
  type: 'website',
  url: 'https://www.xiangjiai.com/',
};

const PageTitle: SFC<PageTitleProps> = ({
  ogDescription = defaultOg.description,
  ogImageUrl = defaultOg.imageUrl,
  ogTitle,
  ogType = defaultOg.type,
  ogUrl = defaultOg.url,
  title,
}) => {
  const titleToUse = `${title} | 图片翻译专家`;
  const ogTitleToUse = ogTitle || titleToUse;
  return (
    <Helmet>
      <title>{titleToUse}</title>
      <meta name="description" property="og:description" content={ogDescription} />
      <meta property="og:image" content={ogImageUrl} />
      <meta property="og:title" content={ogTitleToUse} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={ogUrl} />
    </Helmet>
  );
};

export default PageTitle;
